import React from 'react';
import VstComponent from './VstComponent';

class VstLilHeadUser extends VstComponent {

  render() {
    return (
      <div className="vst-lil-head-user vst-lil-head-section">
        <span className="user-name">{this.props.firstName} {this.props.lastName}</span>
        <span className="user-email">{this.props.email}</span>
      </div>
    );
  }

}

export default VstLilHeadUser;
